import { render, staticRenderFns } from "./import-modal.vue?vue&type=template&id=2923416c&scoped=true&"
import script from "./import-modal.vue?vue&type=script&lang=js&"
export * from "./import-modal.vue?vue&type=script&lang=js&"
import style0 from "./import-modal.vue?vue&type=style&index=0&id=2923416c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2923416c",
  null
  
)

export default component.exports